import React, { useEffect, useMemo } from "react";
import { formatCustomDate } from "helpers/dateTools";
import { useDispatch } from "react-redux";
import { Grid, TextField } from "@material-ui/core";
import { useFixDate } from "hooks/useFixDate";
import { newDate } from "helpers/dateTools";

export const DatesComponent = ({
  dispatchAction = null,
  state, // Initialize with empty strings,
  limitDates = {}
}) => {
  const dispatch = useDispatch();
  useFixDate({
    startDate: state?.startDate,
    endDate: state?.endDate,
    action: dispatchAction,
    isDispatch: true
  });

  // if (!dates) return null;

  return (
    <>
      <Grid item xs={12} sm={2}>
        <TextField
          label="Desde"
          type="date"
          name="startDate"
          value={state?.startDate}
          variant="outlined"
          fullWidth
          required
          onChange={({ target }) => {
            if (state?.[target.name] !== target.value) {
              dispatch(dispatchAction(target.name, target.value));
            }
          }}
          size="small"
          inputProps={{
            min: limitDates?.min || "",
            max: limitDates?.max || newDate()
          }}
        />
      </Grid>

      <Grid item xs={12} sm={2}>
        <TextField
          label="Hasta"
          type="date"
          name="endDate"
          value={state?.endDate}
          variant="outlined"
          fullWidth
          onChange={({ target }) => {
            if (state?.[target.name] !== target.value) {
              dispatch(dispatchAction(target.name, target.value));
            }
          }}
          size="small"
          inputProps={{
            min: limitDates?.min || "",
            max: limitDates?.max || newDate()
          }}
        />
      </Grid>
    </>
  );
};
